module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/GolfCart/indoor-boat.jpg";